var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineDocumentCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "vuesax/outline/document-copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4 22.75H7.6c-4.39 0-6.35-1.96-6.35-6.35v-3.8c0-4.39 1.96-6.35 6.35-6.35h3a.755.755 0 01.75.75.755.755 0 01-.75.75h-3c-3.58 0-4.85 1.27-4.85 4.85v3.8c0 3.58 1.27 4.85 4.85 4.85h3.8c3.58 0 4.85-1.27 4.85-4.85v-3a.75.75 0 011.5 0v3c0 4.39-1.96 6.35-6.35 6.35z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M17 14.151h-3.2c-2.81 0-3.95-1.141-3.95-3.951V7a.741.741 0 01.46-.69.757.757 0 01.82.16l6.4 6.4a.753.753 0 01.16.82.741.741 0 01-.69.461zM11.35 8.81v1.39c0 1.99.46 2.45 2.45 2.45h1.39zM15.6 2.75h-4a.755.755 0 01-.75-.75.755.755 0 01.75-.75h4a.755.755 0 01.75.75.755.755 0 01-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M7 5.75A.755.755 0 016.25 5 3.751 3.751 0 0110 1.25h2.62a.755.755 0 01.75.75.755.755 0 01-.75.75H10A2.253 2.253 0 007.75 5a.755.755 0 01-.75.75zM19.19 17.75a.75.75 0 010-1.5 2.063 2.063 0 002.06-2.06V8a.75.75 0 011.5 0v6.19a3.568 3.568 0 01-3.56 3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M22 8.751h-3c-2.66 0-3.75-1.091-3.75-3.751V2a.741.741 0 01.46-.69.757.757 0 01.82.16l6 6a.753.753 0 01.16.82.741.741 0 01-.69.461zM16.75 3.81V5c0 1.83.42 2.251 2.25 2.251h1.19z"
  }))));
}
export default SvgVuesaxOutlineDocumentCopy;